"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attributeSortMatcher = exports.measureSortMatcher = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var findIndex_1 = tslib_1.__importDefault(require("lodash/findIndex"));
function attributeLocatorMatch(col, locator) {
    var _a = col.seriesDescriptor, attributeDescriptors = _a.attributeDescriptors, attributeHeaders = _a.attributeHeaders;
    var _b = locator.attributeLocatorItem, attributeIdentifier = _b.attributeIdentifier, element = _b.element;
    if (!attributeDescriptors || !attributeHeaders) {
        return false;
    }
    var attributeIdx = findIndex_1.default(attributeDescriptors, function (d) { return d.attributeHeader.localIdentifier === attributeIdentifier; });
    if (attributeIdx === -1) {
        return false;
    }
    // if this happens then either data access infrastructure or the col descriptor method is hosed. there must
    // always be same number of descriptors and headers.
    ts_invariant_1.default(attributeHeaders[attributeIdx]);
    return attributeHeaders[attributeIdx].attributeHeaderItem.uri === element;
}
function measureLocatorMatch(col, locator) {
    var measureDescriptor = col.seriesDescriptor.measureDescriptor;
    var measureIdentifier = locator.measureLocatorItem.measureIdentifier;
    return measureDescriptor.measureHeaderItem.localIdentifier === measureIdentifier;
}
function measureSortMatcher(col, sortItem) {
    return (sdk_model_1.isMeasureSort(sortItem) &&
        sdk_model_1.sortMeasureLocators(sortItem).every(function (locator) {
            if (sdk_model_1.isAttributeLocator(locator)) {
                return attributeLocatorMatch(col, locator);
            }
            else {
                return measureLocatorMatch(col, locator);
            }
        }));
}
exports.measureSortMatcher = measureSortMatcher;
function attributeSortMatcher(col, sortItem) {
    return (sdk_model_1.isAttributeSort(sortItem) &&
        col.attributeDescriptor.attributeHeader.localIdentifier ===
            sortItem.attributeSortItem.attributeIdentifier);
}
exports.attributeSortMatcher = attributeSortMatcher;
//# sourceMappingURL=colSortItemMatching.js.map